import { render, staticRenderFns } from "./Office.vue?vue&type=template&id=0570c40c&scoped=true&"
import script from "./Office.vue?vue&type=script&lang=js&"
export * from "./Office.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0570c40c",
  null
  
)

export default component.exports